const contentStyle = {
  padding: 50,
  background: "rgba(0, 0, 0, 0.05)",
  borderRadius: 4,
};
export const spinContent = <div style={contentStyle} />;

export const colorOptions = [
  { color: "Black", colorCode: "#000000" },
  { color: "White", colorCode: "#ffffff" },
  { color: "Red", colorCode: "#ff0000" },
  { color: "Blue", colorCode: "#0000ff" },
  { color: "Green", colorCode: "#008000" },
  { color: "Yellow", colorCode: "#ffff00" },
  { color: "Gray", colorCode: "#808080" },
  { color: "Light Gray", colorCode: "#d3d3d3" },
  { color: "Dark Gray", colorCode: "#a9a9a9" },
  { color: "Charcoal Gray", colorCode: "#36454f" },
  { color: "Beige", colorCode: "#f5f5dc" },
  { color: "Brown", colorCode: "#8b4513" },
  { color: "Dark Brown", colorCode: "#654321" },
  { color: "Light Brown", colorCode: "#a0522d" },
  { color: "Cream", colorCode: "#fffdd0" },
  { color: "Off-White", colorCode: "#f8f8ff" },
  { color: "Baby Pink", colorCode: "#f4c2c2" },
  { color: "Hot Pink", colorCode: "#ff69b4" },
  { color: "Lavender", colorCode: "#e6e6fa" },
  { color: "Mint Green", colorCode: "#98ff98" },
  { color: "Light Blue", colorCode: "#add8e6" },
  { color: "Peach", colorCode: "#ffdab9" },
  { color: "Gold", colorCode: "#ffd700" },
  { color: "Silver", colorCode: "#c0c0c0" },
  { color: "Bronze", colorCode: "#cd7f32" },
  { color: "Copper", colorCode: "#b87333" },
  { color: "Rose Gold", colorCode: "#b76e79" },
  { color: "Bright Orange", colorCode: "#ffa500" },
  { color: "Burnt Orange", colorCode: "#cc5500" },
  { color: "Royal Purple", colorCode: "#7851a9" },
  { color: "Violet", colorCode: "#8a2be2" },
  { color: "Teal", colorCode: "#008080" },
  { color: "Turquoise", colorCode: "#40e0d0" },
  { color: "Maroon", colorCode: "#800000" },
  { color: "Olive Green", colorCode: "#808000" },
  { color: "Forest Green", colorCode: "#228b22" },
  { color: "Terracotta", colorCode: "#e2725b" },
  { color: "Navy Blue", colorCode: "#000080" },
  { color: "Khaki", colorCode: "#f0e68c" },
  { color: "Coral", colorCode: "#ff7f50" },
  { color: "Mustard", colorCode: "#ffdb58" },
  { color: "Magenta", colorCode: "#ff00ff" },
  { color: "Wine", colorCode: "#722f37" },
  { color: "Ivory", colorCode: "#fffff0" }
];

export const sizeOptions = [
  { label: "large", value: "lg" },
  { label: "medium", value: "md" },
  { label: "small", value: "sm" },
];

export const schemaTypes = [
  { label: "Product Schema", value: "1" },
  { label: "BreedCrumb Schema", value: "2" },
  { label: "Review Schema", value: "3" },
  { label: "FAQ Schema", value: "4" },
];

export const topicTypes = [
  { label: "Advertisement", value: 1 },
  { label: "Products", value: 2 },
  { label: "Categories", value: 3 },
];

export const advertisementTiles = [
  { label: "One in a row", value: 1 },
  { label: "Two in a row", value: 2 },
  { label: "Three in a row", value: 3 },
  { label: "Four in a row", value: 4 },
  { label: "Six in a row", value: 5 },
  { label: "Eight in a row", value: 6 },
];

export const aspectRatiosDesktop = [
  { label: "3:4", ratio: 3 / 4 },
  { label: "3:2", ratio: 3 / 2 },
  { label: "1:1", ratio: 1 / 1 },
  { label: "2:1", ratio: 2 / 1 },
  { label: "3:1", ratio: 3 / 1 },
  { label: "4:1", ratio: 4 / 1 },
  { label: "5:1", ratio: 5 / 1 },
  { label: "6:1", ratio: 6 / 1 },
];

export const aspectRatiosMobile = [
  { label: "3:4", ratio: 3 / 4 },
  { label: "3:2", ratio: 3 / 2 },
  { label: "1:1", ratio: 1 / 1 },
  { label: "2:1", ratio: 2 / 1 },
];

export const tileCountToAspectRatiosDesktop = {
  1: ["3:1", "4:1", "5:1", "6:1"],
  2: ["3:2", "2:1", "3:1"],
  3: ["3:2", "2:1"],
  4: ["1:1", "3:4"],
  5: ["1:1", "3:4"],
  6: ["1:1", "3:4"],
};

export const tileCountToAspectRatiosMobile = {
  1: ["1:1", "2:1", "3:2", "3:4"],
  2: ["1:1", "3:4"],
  3: ["1:1", "3:4"],
  4: ["1:1", "3:4"],
  5: ["1:1", "3:4"],
  6: ["1:1", "3:4"],
};

export const categoryOptions = [
  { label: "Category Layer 1", value: 1 },
  { label: "Category Layer 2", value: 2 },
  { label: "Category Layer 3", value: 3 },
];

export const topicTypeOptions = [
  { label: "Categories", value: 3 },
  { label: "Products", value: 2 },
];

export const recentSearches = [
  { label: "Categories", value: "categories" },
  { label: "Products", value: "products" },
];